import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useDispatch, useSelector } from "react-redux";
import {
  StyledModal,
  StyledModalContent,
  ModalTitle,
  StyledModalText,
  StyledNewButton,
  StyledLink,
} from "./TaxNumberInvalidModal.styled";
import { getTaxNumberInvalid } from "../../reducers/taxNumberInvalidModal";

const TaxNumberInvalidModal = ({ isMobile, setShowInvalidTaxNumberModal }) => {
  const { page_content, loading } = useSelector(
    (state) => state.taxNumberInvalidModal
  );

  const { value: languageCode } = useSelector((state) => state.languageOptions);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTaxNumberInvalid(languageCode));
  }, [dispatch, languageCode]);

  React.useEffect(() => {
    if (window.digitalData) {
      window.digitalData.push({
        event: {
          name: "click",
          category: "pop-up",
          label: "vat-invalid",
          action: "open",
        },
      });
    }
  }, []);

  return (
    !loading && (
      <StyledModal isMobile={isMobile} showXButton={false}>
        <StyledModalContent>
          <ModalTitle>{page_content?.header}</ModalTitle>

          <StyledModalText>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {page_content?.body}
            </ReactMarkdown>
          </StyledModalText>
          {page_content?.understand_button?.value ? (
            <StyledLink>
              <StyledNewButton
                data-cy="link-tax-number-invalid-modal-understand-button"
                isMobile={isMobile}
                onClick={() => setShowInvalidTaxNumberModal()}
                text={page_content?.understand_button?.label}
              />
            </StyledLink>
          ) : (
            <StyledNewButton
              data-cy="no-link-tax-number-invalid-modal-understand-button"
              isMobile={isMobile}
              onClick={() => setShowInvalidTaxNumberModal()}
              text={page_content?.understand_button?.label}
            />
          )}
        </StyledModalContent>
      </StyledModal>
    )
  );
};

TaxNumberInvalidModal.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  setShowInvalidTaxNumberModal: PropTypes.func.isRequired,
};

export default TaxNumberInvalidModal;
